import React, { useState, useEffect } from 'react';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import SubNav from '../../Components/Photography/SubNav';
import ImageGallery from '../../Components/Photography/ImageGallery';
import Modal from '../../Components/Photography/Modal';
import config from '../../config';
import './photoslist.css';

const PhotosList = () => {

//--> Photo List

	// Constants are used to load 4 different columns for the image gallery
	// for responsiveness purposes
 	const [column1, setColumn1State] = useState([]);
 	const [column2, setColumn2State] = useState([]);
 	const [column3, setColumn3State] = useState([]);
 	const [column4, setColumn4State] = useState([]);
 	// photos is used to control the photos loaded in the columns based on navigation
	const [photos, setPhotos] = useState([]);
	const [filteredPhotos, setFilteredPhotos] = useState([]);
	// states for the modal 
 	const [modalPhoto, setModalPhoto] = useState(null); // Change from an array to a single object
 	const [modalPhotoIndex, setModalPhotoIndex] = useState([]);
 	const [isModalOpen, setIsModalOpen] = useState(false); // Use state to control modal visibility
 	const [hasPrev, setHasPrev] = useState(false);
	const [hasNext, setHasNext] = useState(false);

	const navigationItems = [
		{ id: 1, label: 'Show All'},
		{ id: 2, label: 'Coastal'},
		{ id: 3, label: 'Mountains'},
		{ id: 4, label: 'Forest'},
		{ id: 5, label: 'Autumn'},
		{ id: 6, label: 'Winter'},
		{ id: 7, label: 'Light'},
		{ id: 8, label: 'Hiking'},
		{ id: 9, label: 'Wildlife'},
		{ id: 10, label: 'Panorama'},
		{ id: 11, label: 'Portraits'}
	];
	
const createColumns = (array) => {
    const column1Array = [];
    const column2Array = [];
    const column3Array = [];
    const column4Array = [];

    array.forEach((image, i) => {
        if (i % 4 === 0) column1Array.push(image);
        else if (i % 4 === 1) column2Array.push(image);
        else if (i % 4 === 2) column3Array.push(image);
        else column4Array.push(image);
    });

    setColumn1State(column1Array);
    setColumn2State(column2Array);
    setColumn3State(column3Array);
    setColumn4State(column4Array);
};

	// Function to load filtered image data into the gallery
  const filterPhotos = (category) => {
    let filteredArray = category === 'Show All' ? photos : photos.filter(photo => photo.category.includes(category));
    setFilteredPhotos(filteredArray);
    createColumns(filteredArray);
  };

//--> MODAL JAVASCRIPT

// OPEN MODAL
const openModal = (photo) => {
  if (!photo || !photo.id) {
    return;
  }
  setModalPhoto(photo);
  setModalPhotoIndex(filteredPhotos.findIndex(p => p.id === photo.id));
  setIsModalOpen(true); // Set modal state to true to show it
};

	// CLOSE MODAL
  const closeModal = () => {
    setIsModalOpen(false); // Set modal state to false to hide it
    setModalPhoto(null); // Reset the photo when the modal is closed
  };

	// Shows the Modal Photo and
	//
	const showPhoto = (id) => {
	  if (!filteredPhotos || filteredPhotos.length === 0) {
	    console.error("Filtered photos are not ready yet.");
	    return;
	  }
	  const photo = filteredPhotos.find((photo) => photo.id === id);

	  if (photo) {
	    openModal(photo);
	    initializeModalNav(filteredPhotos.findIndex(p => p.id === id));
	  } else {
	    console.error("No photo found with id: ", id);
	  }
	};

  const plusSlides = (adder) => {
    const nextIndex = modalPhotoIndex + adder;
    showPhoto(filteredPhotos[nextIndex].id);
  };

  const initializeModalNav = (index) => {
    setHasPrev(index > 0);
    setHasNext(index < filteredPhotos.length - 1);
  };


	useEffect(() => {
		fetch(`${config.apiUrl}/photography`)
		    .then(response => response.json())
		    .then(images => {
		      setPhotos(images);
		      setFilteredPhotos(images);
		      createColumns(images);
		    })
		    .catch(error => console.error('Error fetching blogs', error));
		const activeNavItems = document.getElementsByClassName('cat active-photos');
		if (activeNavItems.length === 0) {
			const showAll = document.getElementById('Show All');
			showAll.className = 'cat active-photos';	
		}
	}, []);

	return (
		<>
			<div className='box-shadow'>
				<SectionHeader name={'Photo Gallery 📸'} />
				<SubNav 
					filterPhotos = {filterPhotos} 
					navigationItems = {navigationItems} 
				/>
				<ImageGallery 
					column1={column1} 
					column2={column2} 
					column3={column3} 
					column4={column4} 
					openModal={openModal} 
					showPhoto={showPhoto} 
				/>
			</div>
			<div id='lightbox-container' className={isModalOpen ? 'active' : ''}>
				<Modal 
					modalPhoto={modalPhoto} 
					openModal={openModal}
					closeModal={closeModal}
					plusSlides={plusSlides} 
					hasPrev={hasPrev}
					hasNext={hasNext}
				/>
			</div>
		</>
	)
}

export default PhotosList;